<template>
    <div style="width: 100%">
        <div style="width: 100%;height: 30px;background-color: #e3e3e3;display: flex;font-size: 13px">
            <div style="margin: auto 0;color: #595a5a;padding-left: 20px"><span >当前位置：</span></div>
            <el-breadcrumb separator-class="el-icon-arrow-right" style="margin: auto 0;font-size: 13px">
                <el-breadcrumb-item v-for="(item,index) in $route.meta.position" :key="index">
                    {{item}}
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <!-- 基本信息 -->
        <div style="background-color: #FFFFFF;">
            <el-container>
                <!-- 头部 -->
                <el-header style="color: #A2A2A2;margin-top: 15px" height="25px"><strong>基本信息</strong></el-header>
                <!-- 分割线 -->
                <el-divider margin="8px,0"></el-divider>
                <!-- 主内容 -->
                <el-main>
                    <el-form title="" ref="form" :model="form" label-width="80px"
                             style="margin-left: 50px">
                        <el-form-item label="供应商: " prop="code">
                            <template>
                                <el-select clearable  v-model="form.gysValue" placeholder="请选择" style="width: 500px">
                                    <el-option
                                            v-for="item in gysOptions"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                    </el-option>
                                </el-select>
                            </template>
                        </el-form-item>
                    </el-form>
                </el-main>
            </el-container>
        </div>
        <!--中间按钮-->
        <div style="margin-top: 10px">
            <el-button type="success" @click="addSP">添加商品</el-button>
        </div>
        <!--商品信息表格-->
        <div style="margin-top: 10px;background-color: white">
            <template>
                <el-table
                        :data="tableData"
                        border
                        style="width: 100%"
                        :header-cell-style="{background:'#B0C4DE',color:'#595a5a'}">
                    <el-table-column
                            prop="date"
                            label="商品信息" align="center">
                        <template slot-scope="scope">
                            <img :src="scope.row.img" width="100" height="100"/>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="name"
                            label="单价">
                    </el-table-column>
                    <el-table-column
                            prop="address"
                            label="数量">
                    </el-table-column>
                    <el-table-column
                            prop="address"
                            label="小计">
                    </el-table-column>
                    <el-table-column prop="handel" label="操作" align="center">
                        <template slot-scope="scope">
                            <el-button type="text" size="mini" style="margin-top: 2px">移除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </template>
            <div style="margin-top: 30px;border-bottom: 1px solid #DCDFE6;border-top: 1px solid #DCDFE6;">
                <el-row>
                    <el-col :span="18" style="margin-top: 10px">
                        <el-form :inline="true" title="" ref="form2" :model="form2" label-width="80px"
                                 style="margin-left: 50px">
                            <el-form-item label="采购运费:" label-width="100px">
                                <el-row>
                                    <el-input v-model="money" style="width: 50px" :disabled=true></el-input>
                                    <el-input v-model="form2.cgyf" style="width: 100px" placeholder="可不填"></el-input>
                                </el-row>
                            </el-form-item>
                            <el-form-item label="其他费用:" label-width="150px">
                                <el-row>
                                    <el-input v-model="money" style="width: 50px" :disabled=true></el-input>
                                    <el-input v-model="form2.qtfy" style="width: 100px" placeholder="可不填"></el-input>
                                </el-row>
                            </el-form-item>
                            <el-form-item label="预计到货: " label-width="150px">
                                <template slot-scope="scope">
                                    <el-select clearable  v-model="form2.tsValue" placeholder="请选择" style="width: 100px">
                                        <el-option
                                                v-for="item in tsOptions"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                        </el-option>
                                    </el-select>
                                </template>
                            </el-form-item>
                            <el-form-item label="采购备注:" label-width="100px">
                                <el-row>
                                    <el-input v-model="form2.remark" style="width: 400px" placeholder=""></el-input>
                                </el-row>
                            </el-form-item>
                        </el-form>
                    </el-col>
                    <el-col :span="6" style="margin-top: 10px">
                        <span>商品种类:</span><span style="margin-left: 30px">1</span><br>
                        <span>商品数量:</span><span style="margin-left: 30px">x2</span><br>
                        <span>采购总额:</span><span style="margin-left: 30px"><font color="red">¥99</font></span>
                    </el-col>
                </el-row>
            </div>
        </div>
        <!--底栏-->

        <div style="margin-top: 20px;border-bottom: 1px solid #DCDFE6;border-top: 1px solid #DCDFE6;background-color: white">
            <el-row>
                <el-col :span="15" style="text-align: right">
                    <span>运输费用：¥2.00   应付总额：</span>
                    <span style="margin-left: 15px">
                        <font color="red" size="5">¥99</font>
                    </span>
                </el-col>
                <el-col :span="8" style="margin-top: 5px;text-align: right;margin-bottom: 30px">
                    <el-button type="primary" size="mini">暂存</el-button>
                    <el-button type="primary" size="mini">保存并提交审核</el-button>
                    <el-button type="info" size="mini">取消</el-button>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
    export default {
        data: function () {
            return {
                //钱标志
                money: '¥',
                gysOptions: [{
                    value: '选项1',
                    label: '黄金糕'
                }, {
                    value: '选项2',
                    label: '双皮奶'
                }, {
                    value: '选项3',
                    label: '蚵仔煎'
                }, {
                    value: '选项4',
                    label: '龙须面'
                }, {
                    value: '选项5',
                    label: '北京烤鸭'
                }],
                //到货天数
                tsOptions: [{
                    value: '选项1',
                    label: '1天内'
                }, {
                    value: '选项2',
                    label: '2天内'
                }, {
                    value: '选项3',
                    label: '3天内'
                }, {
                    value: '选项4',
                    label: '4天内'
                }, {
                    value: '选项5',
                    label: '5天内'
                }],
                form: {
                    gysValue: ''
                },
                form2: {
                    cgyf: '',
                    tsValue: '',
                    qtfy:'',
                    remark:''
                },
                tableData: [{
                    img: 'https://dss0.bdstatic.com/70cFuHSh_Q1YnxGkpoWK1HF6hhy/it/u=1906469856,4113625838&fm=26&gp=0.jpg',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1518 弄'
                }, {
                    img: 'https://dss0.bdstatic.com/70cFuHSh_Q1YnxGkpoWK1HF6hhy/it/u=1906469856,4113625838&fm=26&gp=0.jpg',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1517 弄'
                }, {
                    img: 'https://dss0.bdstatic.com/70cFuHSh_Q1YnxGkpoWK1HF6hhy/it/u=1906469856,4113625838&fm=26&gp=0.jpg',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1519 弄'
                }, {
                    img: 'https://dss0.bdstatic.com/70cFuHSh_Q1YnxGkpoWK1HF6hhy/it/u=1906469856,4113625838&fm=26&gp=0.jpg',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1516 弄'
                }]


            };
        },
        methods: {
            addSP(){
                //直接跳转
                this.$router.replace('/addSP')
            }
        }
    }
</script>

<style>
    .head .el-dialog__header {
        background-color: #eef1f6;
    }
</style>
